export default {
      id: "contracts-usage",
      viewBox: "0 0 22.41 15.41",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#contracts",
      toString: function () {
        return this.url;
      }
    }